<script setup>
import { ref } from "vue";
import ContentSearchFieldWrapper from 'shared/components/contentLibrary/contentLibraryWrappers/contentSearchFieldWrapper.vue';
import SearchFieldWrapper from 'shared/components/product/searchFieldWrapper.vue';

import useProductList from 'shared/components/product/composables/useProductList.js';
import useContentLibrary from 'shared/components/contentLibrary/composables/useContentLibrary.js';

const productListComposable = ref(null);
const contentLibraryComposable = ref(null);

productListComposable.value = useProductList();
contentLibraryComposable.value = useContentLibrary();

</script>
<template>
	<div class="hero-search-placeholder" v-if="productListComposable?.displaySearchOnHero || contentLibraryComposable?.displaySearchOnHero">
		<template v-if="productListComposable?.displaySearchOnHero">
			<SearchFieldWrapper />
		</template>
		<template v-else-if="contentLibraryComposable?.displaySearchOnHero">
			<ContentSearchFieldWrapper />
		</template>
	</div>
</template>

<style lang="scss">
@import 'multisite/styles/settings/settings';
@import 'multisite/styles/tools/tools';
$margin-left: 84px;

.hero-search-placeholder {
	width: calc(100% - 84px);
	margin-left: $margin-left;
	margin-top: ds-space(10);
	display: flex;


	.facet__button__container {
		margin: 0 0 0 ds-space(4);
		border: 1px solid ds-color('border', 'strong');
		background: ds-color('bg', 'default');
	}

	.c-search.c-search--product-page {
		width: 100%;
		margin-bottom: 0;
		margin-left: 0;
	}

	.c-content-library__topcontainer {
		flex-wrap: nowrap;
		flex-direction: row;
		width: 100%;
		margin-bottom: 0;

		.c-content-search__button {
			order: 1;
			z-index: 1;
			left: 2px;
		}

		.c-content-search__field {
			order: 2;
			margin-left: -45px;
			padding-left: 46px;
		}

		.c-content-search__wrapper {
			flex: auto;
		}
	}

	.hide-on-desktop {
		display: none;
	}

	.hide-on-mobile {
		display: flex;
	}

	.c-content-library__topcontainer-button {
		border: 1px solid ds-color('border', 'strong');
		background: ds-color('bg', 'default');
	}
}

.no-media .hero-search-placeholder {
	margin-left: 0;
	width: 100%;
}

.reverse .hero-search-placeholder {
	margin-left: ds-space(10);
	margin-right: 84px;
	width: auto;

	@include t-respond-to-max(ds-breakpoint('xl')) {
		width: calc(100% - 84px);
	}

	.c-search.c-search--product-page {
		margin-left: 0;
	}
}

@include t-respond-to-max(ds-breakpoint('md')) {
	.hero-search-placeholder,
	.reverse .hero-search-placeholder {
		margin: 0;
		width: 100%;

		.c-content-library__topcontainer-button {
			margin: 0 0 0 ds-space(4);
		}
	}
}
</style>
